import { SteppedProgressBar } from "@rio-cloud/rio-uikit";

interface Props {
    selected: number;
    onSelectedChanged: (idx: number) => void;
    step?: number;
    disabled?: boolean;
    disabledIndex?: number;
}

export const ProgressOptions = [{
    icon: 'rioglyph rioglyph-calendar',
    title: 'Data',
    route: '/routing/trips/schedule'
}, {
    icon: 'rioglyph rioglyph-user',
    title: 'Motorista',
    route: '/routing/trips/driver'
}, {
    icon: 'rioglyph rioglyph-truck-baseline',
    title: 'Veículo',
    route: '/routing/trips/vehicle'
}, {
    icon: 'rioglyph rioglyph-route-view',
    title: 'Viagem',
    route: '/routing/trips/custom'
}]

const Trip = ({ selected, onSelectedChanged, step, disabledIndex }: Props) => {
    return (
        <div>
            <SteppedProgressBar
                variant={SteppedProgressBar.VARIANT_ROADSIGN}
                selectedStepNumber={selected}
                onSelectedChanged={onSelectedChanged}
                mobileBreakpoint={true}
                disableFollowingPages={disabledIndex}
                labels={ProgressOptions.map((o, idx) => {
                    const isSelected = step === idx;
                    return {
                        icon: <i className={`${o.icon} ${!isSelected ? 'text-color-gray' : 'text-color-primary'}`} />,
                        label: o.title,
                        labelClassName: !isSelected ? 'text-color-gray' : 'text-color-primary',
                    }
                })}
            />
        </div>
    )
}

export default Trip;